module.exports = __webpack_public_path__ + "img/13.7249d1c1.jpg";